import { useSMLRoute } from '../../../../routing/sml/hooks';
import { useUserToken } from '../../../../redux/slices/appInfo/hooks';
import { isPublicShareRouteName } from '../../../music24/assetShare/sharedAssetRoute';

export function useShouldShowNavbar(): boolean {
  const route = useSMLRoute();
  const userToken = useUserToken();
  if (!route) {
    return false;
  }
  if (userToken) {
    return true;
  }
  // Anonymous viewers still see the navbar on the public share pages (`/app/public/:code`,
  // `/app/a/:token`), where the right-side button becomes "Start a 7-day trial".
  return isPublicShareRouteName(route[0]);
}
